<template>
  <vs-row vs-justify="center" vs-align="center" class="full-height login-register-bg">
    <vs-col type="flex"  vs-justify="center" vs-align="center" class="login-register-box" vs-lg="12" vs-xs="12">
      <vs-card v-show="!showConfirm" class="mb-0">
        <div slot="header">
          <h3 class="mb-1">Register Here</h3>
          <p class="mb-0">Welcome, please fill in your credentials.</p>
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger"  :active="!formDataChanged">
          <b>Please correct the following error(s):</b>
          <ul class="common-list">
            <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
          </ul>
        </vs-alert>
        <form @submit="checkForm" novalidate="true">
          <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" icon="mail" placeholder="Email" v-model="username" type="email"/>
          <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" type="password" icon="lock" placeholder="Password" v-model="password"/>
          <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" type="password" icon="lock" placeholder="Repeat password" v-model="password2"/>
          <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 vs-input-large" icon="person" placeholder="Your Name" v-model="name" type="text"/>
          <input class="btn-block btn btn-primary submit-button mt-3" @click.stop.prevent="onSubmit" type="submit" value="Register"/>
        </form>
       <div class="d-flex justify-content-center mt-3">
         <span class="mr-1">Do you have an account?</span><router-link to="/site/login"> Login</router-link>
       </div>
      </vs-card>

      <vs-card v-show="showConfirm" class="mb-0">
        <div slot="header">
          <h3 class="mb-1">Подтверждения электронного адреса</h3>
          <p class="mb-1">Для завершения регистрации необходимо подтвердить ваш электронный адрес.</p>
        </div>
        <P class="mb-1">Мы только что отправили вам письмо, которое содержит код, необходимый для завершения регистрации. Пожалуйста скопируйте его
        в текстовое поле ниже, или просто пройдите по ссылке, отправленной в том же письме.
        </P>
        <form @submit="checkConfirm" novalidate="true">
          <vs-input icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" icon="mail" placeholder="Activation code" v-model.trim="activationCode" type="text"/>
          <input class="btn-block btn btn-primary submit-button mt-3" @click.stop.prevent="onConfirm" type="submit" value="Confirm"/>
        </form>

        <div class="d-flex justify-content-center mt-3">
          <span class="mr-1">Do you have an account?</span><router-link to="/site/login"> Login</router-link>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>

</template>

<script>
import { AuthService } from './../../services/auth.service'
import NProgress from 'nprogress';

export default {
  name: 'Register',
  data:()=>({
    rememberme:false,
    name:'',
    username:'',
    password:'',
    password2:'',
    errors:[],
    formDataChanged: false,
    showConfirm: false,
    activationCode:''
  }),
  methods:{
    changeLoginData: function(e){
      if (e.key !== 'Enter') {
        this.formDataChanged = true;
      }
    },

    checkForm:function(e) {
      this.errors = [];
      this.formDataChanged = false;
      if(!this.username) {
        this.errors.push("Email required.");
      } else if(!this.validEmail(this.username)) {
        this.errors.push("Valid email required.");
      }
      if(!this.name) this.errors.push("Name required.");
      if(!this.password) this.errors.push("Password required.");
      if (this.password !== this.password2) {
        this.errors.push('Passwords must be equal')
      }
      if(!this.errors.length) return true;
      e.preventDefault();
    },


    /* eslint-disable */
    validEmail:function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    /* eslint-enable */

    onSubmit: function(e){
      if (this.checkForm(e)) {
        this.sendLogin();
      } else {
        e.preventDefault();
      }
    },

    sendLogin: function(){
      this.errors = [];
      NProgress.start();

      AuthService.makeSignup({
        username: this.username,
        password: this.password,
        name: this.name
      })
        .then(response => {
          NProgress.done();
          if (response.send) {
            this.showConfirm = true;
          } else {
            this.showConfirm = false;
          }
        })
        .catch( error => {
          NProgress.done();
          this.errors = error.apply();
        });
    },

    checkConfirm: function(e){
      if (this.activationCode) {
        return true;
      }
      e.preventDefault();
      return false;
    },

    onConfirm: function (e) {
      if (this.checkConfirm(e)) {
        this.$router.push({name: 'confirm', params:{
          token: this.activationCode
        }});
      } else {
        e.preventDefault();
      }
    }
  }
}
</script>
<style>
.login-register-bg{
  margin:0 auto;
  background:url(../../assets/images/background/auth-bg.jpg) no-repeat center center;
}
.login-register-box{
  max-width:400px;
}

</style>

